<div class="lui-toggle-list-item__container h-100">
  <div
    class="lui-toggle-list-item__header d-flex flex-1 align-items-center justify-content-between p-2"
    (click)="toggle()"
  >
    <div class="pe-1">
      <ng-container *ngTemplateOutlet="title.templateRef"></ng-container>
    </div>
    <mat-icon [svgIcon]="expanded ? 'chevron_up' : 'chevron_down'"></mat-icon>
  </div>

  <div [style.display]="expanded ? '' : 'none'">
    <ng-content></ng-content>
  </div>
</div>
